import { eTipoPermissao } from '@/enums/ePermissoes';
export default [
  {
    description: 'Cadastro de Atividades no Calendário',
    path: '/calendario/atividadesmes/:calendarioId?/:ensinoId?',
    name: 'calatividadesmes',
    component: () => import('@/views/calendario/atividadesMes/Index.vue'),
    meta: {
      permissions: [eTipoPermissao.CALENDARIOREDEDEENSINONOVO_MENU_200100199, eTipoPermissao.CALENDARIOUNIDADEESCOLARNOVO_MENU_200100299],
    },
    goesToMenu: true,
    props: true,
  },
];
